import api from "./api";

// ─── Rider Reviews ────────────────────────────────────────────────────────────

export const createRiderReviewApi = async (payload) => {
  const { data } = await api.post("/api/v1/reviews/rider", payload);
  return data;
};

export const getRiderReviewsApi = async (riderId, params = {}) => {
  const { data } = await api.get(`/api/v1/reviews/rider/${riderId}`, { params });
  return { reviews: data.data || [], avg: data.meta?.avg || 0, count: data.meta?.count || 0 };
};

// ─── Seller Reviews ───────────────────────────────────────────────────────────

export const createSellerReviewApi = async (payload) => {
  const { data } = await api.post("/api/v1/reviews/seller", payload);
  return data;
};

export const getSellerReviewsApi = async (sellerId, params = {}) => {
  const { data } = await api.get(`/api/v1/reviews/seller/${sellerId}`, { params });
  return data;
};

// ─── Product Reviews ──────────────────────────────────────────────────────────

export const createProductReviewApi = async (payload) => {
  const { data } = await api.post("/api/v1/reviews/product", payload);
  return data;
};

export const getProductReviewsApi = async (productId, params = {}) => {
  const { data } = await api.get(`/api/v1/reviews/product/${productId}`, { params });
  return data;
};
